import { initializePaddle, Paddle } from '@paddle/paddle-js';
import { useCallback, useEffect, useState } from 'react';

import { useUpgradeCard } from 'apps/shared/scripts/graphql';

import { CheckoutForm } from '../../components';

interface Props {
  cardId: string;
}

const CheckoutFormContainer = ({ cardId }: Props) => {
  /**
   * Paddle.js
   * https://github.com/PaddleHQ/paddle-js-wrapper
   */
  const [paddle, setPaddle] = useState<Paddle>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const [invoiceId, setInvoiceId] = useState<string | undefined>();
  const { mutate: upgradeCard } = useUpgradeCard({
    refetchQueries: ['Card', 'Invoices'],
    awaitRefetchQueries: true,
  });

  const onCheckoutCompleted = useCallback(
    async (data: { transaction_id: string }) => {
      const { result: invoice } = await upgradeCard({
        id: cardId,
        input: { transactionId: data.transaction_id },
      });
      setInvoiceId(invoice!.id);
      setLoading(false);
      setSuccess(true);
    },
    [cardId, upgradeCard],
  );

  useEffect(() => {
    initializePaddle({
      environment: 'sandbox',
      token: process.env.REACT_APP_PADDLE_TOKEN!,
      eventCallback: function (data) {
        if (data.name === 'checkout.completed') {
          document.getElementById('checkout-container')!.style.visibility =
            'hidden';
          document.getElementById('checkout-container')!.style.height = '450px';
          setLoading(true);
          onCheckoutCompleted(data.data!);
        }
      },
    }).then((paddleInstance: Paddle | undefined) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
      }
    });
  }, [onCheckoutCompleted]);

  return (
    <CheckoutForm
      cardId={cardId}
      paddle={paddle}
      isLoading={isLoading}
      isSuccess={isSuccess}
      invoiceId={invoiceId}
    />
  );
};

CheckoutFormContainer.displayName = 'CheckoutFormContainer';

export default CheckoutFormContainer;
